import { ApiAttributeType } from '@components/ui/DynamicForm/DynamicForm';
import React from 'react';
import { Box } from '@radix-ui/themes';
import { ApiAttribute, EndpointAttributes } from '@context/openapi/types';
import { ParamterSection } from '@components/ui/ParameterSection/ParameterSection';

export interface ApiRequestContainerProps {
  options?: IApiRequestContainerOptions;
  updateParams: (params: ApiAttribute[], type: ApiAttributeType) => void;
  isEmptyAttributesVisible: boolean;
  formActions?: React.ReactNode;
}

export interface IApiRequestContainerOptions {
  disable?: boolean;
  endpointAttributes: EndpointAttributes;
  url?: string;
}

export const ApiRequestContainer: React.FC<ApiRequestContainerProps> = ({
  options,
  updateParams,
  isEmptyAttributesVisible,
  formActions,
}) => {
  // Determine which section gets the form actions (first non-empty section)
  const hasPath = (options?.endpointAttributes.pathParameters || []).length > 0;
  const hasQuery = (options?.endpointAttributes.queryParams || []).length > 0;

  const pathActions = hasPath ? formActions : undefined;
  const queryActions = !hasPath && hasQuery ? formActions : undefined;
  const bodyActions = !hasPath && !hasQuery ? formActions : undefined;

  return (
    <Box className="space-y-4">
      <ParamterSection
        type={ApiAttributeType.PATH}
        params={options?.endpointAttributes.pathParameters || []}
        updateParams={updateParams}
        isEmptyAttributesVisible={true}
        actions={pathActions}
      />
      <ParamterSection
        type={ApiAttributeType.QUERY}
        params={options?.endpointAttributes.queryParams || []}
        updateParams={updateParams}
        isEmptyAttributesVisible={isEmptyAttributesVisible}
        actions={queryActions}
      />
      <ParamterSection
        type={ApiAttributeType.BODY}
        params={options?.endpointAttributes.params || []}
        updateParams={updateParams}
        isEmptyAttributesVisible={isEmptyAttributesVisible}
        actions={bodyActions}
      />
    </Box>
  );
};
